import {
  GET_LEAGUE_CARD_DATA_REQUEST,
  GET_LEAGUE_CARD_DATA_SUCCESS,
  GET_LEAGUE_CARD_DATA_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};


export default (state = initialState, action) => {
  let generalStandingsData;

  switch (action.type) {
    case GET_LEAGUE_CARD_DATA_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_LEAGUE_CARD_DATA_SUCCESS:
      
      generalStandingsData = action.payload?.standings?.generalStandings
        ? action.payload?.standings?.generalStandings?.teams?.filter( item => {
          return item.recentForms;
        }) : null;

      return { ...state, data: { ...action.payload, generalStandings: { ...generalStandingsData } }, isLoading: false, error: null };
    case GET_LEAGUE_CARD_DATA_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};

